import React from "react";
import { Label, Error } from 'components/lib';
import Style from "./SearchSelect.module.scss";
import { Autocomplete, TextField } from '@mui/material';

export function SearchableSelect(props) {
  
  function change(event, value) {

    let values = value ? value : [];
    let valid = undefined;

    // validate
    valid = props.required && values?.length === 0 ? false : true;
    // update the parent form
    props.onChange(props.name, values, valid);
    props.callback && props.callback(values)

  }
  return (
    <>

      <Label text={props.label} required={props.required} for={props.name} />
      <div className={Style.mainContainer}>
        <Autocomplete
          id={props?.label || 'auto-complete'}
          {...(props?.isMultiSelect && { multiple: true })}
          limitTags={props.limitTag || 1}
          options={props.options || []}
          value={props.value}
          onChange={change}
          renderInput={(params) => (
            <TextField {...params} placeholder={props.placeholder} fullWidth />
          )}
          isOptionEqualToValue={(option, value) =>
            option.label === value.label
          }
          getOptionLabel={(option) => option.label}
          placeholder={props.placeholder}
        />
      </div>
      {props.valid === false &&
        <Error message={props.errorMessage} />}
    </>
  );
}